import request from "@utils/request";
/**
 * 资讯中心文章列表
 * @param {*} data
 * @returns
 */
export function getNewsList(data) {
  return request({
    url: "/cms/cmsModelKv/news/noAuth/front/v2.4.1/getNewsList",
    method: "get",
    params: data,
  });
}
/**
 * 资讯中心文章详情
 * @param {*} data
 * @returns
 */
export function getNewsDetailById(data) {
  //newsId
  return request({
    url: "/cms/cmsModelKv/newsDetail/noAuth/front/v2.4.1/getNewsDetailById",
    method: "get",
    params: data,
  });
}
/**
 * 口碑文章列表
 * @param {*} data
 * @returns
 */
export function getCommentList(data) {
  return request({
    url: "/community/pgc/noAuth/front/ssh/pubPraise/list",
    method: "get",
    params: data,
  });
}
/**
 * 资讯中心文章详情
 * @param {*} data
 * @returns
 */
export function getPGCDetailById(data) {
  //newsId
  return request({
    url: "/community/pgc/front/v2.2/getById",
    method: "get",
    params: data,
  });
}

/**
 * 资讯中心文章分类
 * @param {*} data
 * @returns
 */
export function getAllType(data) {
  return request({
    url: "/cms/informationContent/noAuth/front/getAllType",
    method: "get",
    params: data,
  });
}
/**
 * 资讯中心文章列表
 * @param {*} data
 * @returns
 */
export function informationContentPage(data) {
  return request({
    url: "/cms/informationContent/noAuth/front/page",
    method: "get",
    params: data,
  });
}
/**
 * 资讯中心文章详情
 * @param {*} data
 * @returns
 */
export function informationContentDetail(data) {
  return request({
    url: "/cms/informationContent/noAuth/front/getContentById",
    method: "get",
    params: data,
  });
}
